// src/services/adminUsers.js
import {
  collection,
  query,
  orderBy,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";

// Fetch all users from the top-level `users` collection.
// Each doc: { role, status, email, createdAt }
export async function fetchUsers() {
  const q = query(collection(db, "users"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

// Update a user's status: "active" | "suspended"
export async function setUserStatus(uid, status) {
  await updateDoc(doc(db, "users", uid), { status });
}